module.exports = __webpack_public_path__ + "img/expand.3bd5be54.svg";